import { render, staticRenderFns } from "./SideBarHeader.vue?vue&type=template&id=0ef02044"
import script from "./SideBarHeader.vue?vue&type=script&lang=js"
export * from "./SideBarHeader.vue?vue&type=script&lang=js"
import style0 from "./SideBarHeader.vue?vue&type=style&index=0&id=0ef02044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports